import { render, staticRenderFns } from "./userMy_titleAttr.vue?vue&type=template&id=379f7d7f&scoped=true"
import script from "./userMy_titleAttr.vue?vue&type=script&lang=js"
export * from "./userMy_titleAttr.vue?vue&type=script&lang=js"
import style0 from "./userMy_titleAttr.vue?vue&type=style&index=0&id=379f7d7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379f7d7f",
  null
  
)

component.options.__file = "userMy_titleAttr.vue"
export default component.exports